<template>
  <div>
    <header>
      <a href="/"><span style="color: #fff; font-weight: 1000; font-size: 1.5rem;">ShopT</span></a>
      <nav>
        <ul :class="{active: menuActive}">
          <li><router-link to="/shop">Shop</router-link></li>
          <li><router-link to="/track">Track</router-link></li>
          <li><router-link to="/review">Reviews</router-link></li>
          <li><router-link to="/safety">Safety</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
          <li><router-link to="/login"><i class="fas fa-user-circle"></i></router-link></li>
          <li>
            <div class="cart-status">
              <button @click="openCart" v-if="btnOpen">
                <i class="fas fa-cart-shopping"></i>
                <span v-if="cartItemCount > 0" class="cart-count">{{ cartItemCount }}</span>
              </button>
            </div>
          </li>
        </ul>
        <label id="icon" @click="openMenu" v-if="btnOpen">
          <i class="fas fa-bars"></i>
        </label>
        <label id="icon-close" @click="closeMenu" v-if="btnClose">
          <i class="fas fa-times"></i>
        </label>
      </nav>
    </header>

    <div :class="{'cart-active': cartActive}" class="cart">
      <button class="fas fa-times-circle close-btn" @click="closeCart"></button>
      <h3>Your Cart</h3>
      <div v-if="cartItems.length === 0">Your cart is empty.</div>
      <div v-for="item in cartItems" :key="item.id" class="cart-item">
        <span>{{ item.name }} - {{ item.quantity }}x</span>
        <span>${{ item.price.toFixed(2) }}</span>
        <button class="remove-btn" @click="removeItem(item.id)">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div v-if="cartItems.length > 0" class="cart-total">
        <strong>Total: ${{ total.toFixed(2) }}</strong>
        <button
            class="checkout-btn"
            :disabled="total < 5"
            @click="$router.push('/checkout')"
        >
          Checkout
        </button>

      </div>
    </div>
  </div>
</template>




<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
      menuActive: false,
      btnOpen: true,
      btnClose: false,
      cartActive: false,
    };
  },
  computed: {
    ...mapGetters(['cart']),

    cartItems() {
      return this.cart.map(item => ({
        ...item,
        price: item.price * item.quantity,
      }));
    },

    cartItemCount() {
      return this.cart.reduce((acc, item) => acc + item.quantity, 0);
    },

    total() {
      return this.cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);
    }
  },
  methods: {
    removeItem(itemId) {
      this.$store.dispatch('removeItemFromCart', itemId);
    },
    openMenu() {
      this.menuActive = true;
      this.btnOpen = false;
      this.btnClose = true;
    },
    closeMenu() {
      this.menuActive = false;
      this.btnOpen = true;
      this.btnClose = false;
    },
    openCart() {
      this.cartActive = true;
    },
    closeCart() {
      this.cartActive = false;
    }
  }
};
</script>

<style scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 60px;
  height: 60px;
  width: 100%;
}

#logo {
  width: 50px;
}

.checkout-btn {
  margin-top: 15px;
  width: 100%;
  padding: 10px;
  background-color: #4ec7f3;
  color: #111;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.checkout-btn:hover {
  background-color: #3ab0db;
}

.remove-btn {
  background: transparent;
  border: none;
  color: #f55;
  font-size: 1.2rem;
  cursor: pointer;
  margin-left: 10px;
}
.remove-btn:hover {
  color: #f99;
}

nav ul {
  display: flex;
  flex-wrap: wrap;
}

nav li {
  margin-left: 10px;
}

nav li a {
  color: #fff;
  padding: 5px 20px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.1rem;
}

nav li button {
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 1.3rem;
  cursor: pointer;
  position: relative;
}

nav li a:hover {
  border-radius: 0.25rem;
  color: #000;
  background-color: #fff;
}

nav li a.active {
  border-radius: 0.25rem;
  color: #000;
  background-color: #fff;
}

nav #icon {
  font-size: 1.3rem;
  color: #fff;
  cursor: pointer;
  display: none;
}

nav #icon-close {
  font-size: 1.3rem;
  color: #fff;
  cursor: pointer;
  display: none;
}

.cart-status {
  position: relative;
  display: inline-block;
}

.cart-count {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #4ec7f3;
  color: #111;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: bold;
}

.cart-total-badge {
  position: absolute;
  top: 20px;
  right: -5px;
  background-color: #4ec7f3;
  color: #111;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.8rem;
  font-weight: bold;
}

@media (max-width: 909px) {
  header {
    padding: 40px 30px;
  }

  #logo {
    width: 40px;
  }

  nav #icon {
    display: block;
  }

  nav #icon-close {
    display: block;
  }

  nav ul {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: #111;
    top: 80px;
    left: -100%;
    text-align: center;
    display: block;
    transition: all .4s;
  }

  nav li {
    margin: 30px 0;
    line-height: 30px;
  }

  nav li a {
    font-size: 1.2rem;
    display: block;
  }

  nav li a:hover {
    border: none;
    background-color: transparent;
    color: #4ec7f3;
  }

  nav ul.active {
    left: 0;
  }

  .cart-total-badge {
    position: static;
    display: inline-block;
    margin-left: 10px;
  }
}

.cart {
  position: fixed;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100vh;
  background-color: #111;
  color: #fff;
  transition: right 0.3s ease;
  padding: 20px;
  z-index: 1000;
}

.cart-active {
  right: 0;
}

.cart .close-btn {
  border: none;
  padding: 10px;
  font-size: 1.5rem;
  border-radius: 50%;
  position: absolute;
  top: 20px;
  right: 20px;
}

.cart h3 {
  margin-top: 60px;
  font-size: 1.5rem;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.cart-total {
  margin-top: 20px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>